import { render, staticRenderFns } from "./ScrollObserver.vue?vue&type=template&id=6f3b8c2c"
import script from "./ScrollObserver.vue?vue&type=script&lang=js"
export * from "./ScrollObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports